import { useEffect, useState } from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  BarChart,
  Bar,
  CartesianGrid,
} from "recharts";

export default function AnimatedChart({ type }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    loadChart();
  }, [type]);

  const loadChart = async () => {
    try {
      const res = await fetch(
        `/api/vendor/dashboard/chart/${type}`,
        {
          credentials: "include",
        }
      );

      const json = await res.json();

      if (json.status === "success") {
        setData(json.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (type === "vendor-payments") {
    return (
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1f2937" />

            <XAxis dataKey="label" stroke="#9ca3af" />

            <YAxis stroke="#9ca3af" />

            <Tooltip
              formatter={(v) => `₹${Number(v).toLocaleString()}`}
              contentStyle={{
                background: "#0b0b0f",
                border: "1px solid rgba(255,255,255,.1)",
                borderRadius: "12px",
              }}
            />

            <Bar
              dataKey="value"
              fill="#facc15"
              radius={[8, 8, 0, 0]}
              animationDuration={800}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }

  return (
    <div className="h-72">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data}>
          <defs>
            <linearGradient id="vendorGold" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#facc15" stopOpacity={0.5} />
              <stop offset="100%" stopColor="#facc15" stopOpacity={0} />
            </linearGradient>
          </defs>

          <XAxis dataKey="label" stroke="#6b7280" />

          <YAxis stroke="#6b7280" />

          <Tooltip
            formatter={(v) =>
              type === "payments"
                ? `₹${Number(v).toLocaleString()}`
                : Number(v)
            }
            contentStyle={{
              background: "#0b0b0f",
              border: "1px solid rgba(255,255,255,.1)",
              borderRadius: "12px",
            }}
          />

          <Area
            type="monotone"
            dataKey="value"
            stroke="#facc15"
            strokeWidth={2}
            fill="url(#vendorGold)"
            animationDuration={900}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}